import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  HStack,
  VStack,
  Avatar,
  Badge,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useAppData } from '../../store/dataStore';

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

const WebinarHero = ({ data }) => {
  const { appData } = useAppData();
  const { nextBatchDate, nextWebinarDate } = appData;

  // Safety check
  const componentData = data || {
    badgeText: 'FREE WEBINAR',
    title: 'Free GenAI Career Webinar',
    subtitle: 'Discover how to break into AI—even with zero experience',
    duration: '45-60 Minutes',
    instructor: {
      name: 'Roopesh Tayaloor',
      role: 'AI Expert & Industry Leader'
    },
    icons: {}
  };

  return (
    <Box
      bg="linear-gradient(135deg, #1E3A8A 0%, #0F172A 100%)"
      color="white"
      py={{ base: 16, md: 24 }}
    >
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Badge
            bg="accent.gold"
            color="brand.800"
            px={4}
            py={2}
            borderRadius="full"
            fontSize="sm"
            fontWeight="600"
            mb={6}
          >
            {componentData.badgeText}
          </Badge>

          <MotionHeading
            as="h1"
            fontSize={{ base: '3xl', md: '5xl', lg: '6xl' }}
            fontFamily="heading"
            mb={6}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            {componentData.title}
          </MotionHeading>
          
          <MotionText
            fontSize={{ base: 'xl', md: '2xl' }}
            mb={8}
            maxW="3xl"
            mx="auto"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {componentData.subtitle}
          </MotionText>

          <HStack
            justify="center"
            spacing={6}
            mb={10}
            flexWrap="wrap"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            <HStack>
              <componentData.icons.event size={20} />
              <Text fontSize="lg">Its on {nextWebinarDate} </Text>
            </HStack>
            <HStack>
              <componentData.icons.time size={20} />
              <Text fontSize="lg">{componentData.duration}</Text>
            </HStack>
          </HStack>

          <MotionBox
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <VStack spacing={3}>
              <Avatar
                size="xl"
                name={componentData.instructor.name}
                bg="accent.green"
              />
              <VStack spacing={1}>
                <Text fontWeight="600" fontSize="lg">
                  {componentData.instructor.name}
                </Text>
                <Text fontSize="sm" color="brand.200">
                  {componentData.instructor.role}
                </Text>
              </VStack>
            </VStack>
          </MotionBox>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WebinarHero;